(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var body = document.body;

  function setMenu(open) {
    if (!toggle || !menu) return;
    if (open) {
      var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      menu.style.top = bottom + 'px';
    }
    body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
  }

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      setMenu(!body.classList.contains('menu-open'));
    });
    var overlay = menu.querySelector('[data-menu-close]');
    if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMenu(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 749) setMenu(false);
    });
  }

  /* ---------- Product page ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    /* Image gallery: dots follow swipe, dots scroll to slide */
    var slides = root.querySelector('[data-slides]');
    var dots = root.querySelectorAll('[data-dot]');
    if (slides && dots.length) {
      var ticking = false;
      slides.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(slides.scrollLeft / slides.clientWidth);
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
          ticking = false;
        });
      }, { passive: true });

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          slides.scrollTo({ left: slides.clientWidth * Number(d.getAttribute('data-dot')), behavior: 'smooth' });
        });
      });
    }

    /* Variant selection */
    var dataEl = root.querySelector('[data-variants]');
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add]');
    var fieldsets = root.querySelectorAll('[data-option]');
    if (!dataEl || !idInput || !addBtn || !fieldsets.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markSoldOut() {
      var selected = selectedOptions();
      fieldsets.forEach(function (fs, pos) {
        fs.querySelectorAll('input').forEach(function (input) {
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          var any = variants.some(function (v) {
            return v.available && v.options.every(function (opt, i) {
              return i === pos ? opt === input.value : opt === selected[i];
            });
          });
          label.classList.toggle('is-soldout', !any);
        });
      });
    }

    function update() {
      var selected = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      markSoldOut();

      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to cart — ' + match.price : 'Sold out';

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-option]')) update();
    });

    markSoldOut();
  });

  /* ---------- Cart: submit when quantity changes ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.form;
      if (!form) return;
      var updateBtn = form.querySelector('[name="update"]');
      if (form.requestSubmit && updateBtn) {
        form.requestSubmit(updateBtn);
      } else {
        form.submit();
      }
    });
  });
})();
